import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { ArrowLeft } from 'lucide-react';

const ConfidentialitePage = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: '#E9DFCF' }} data-testid="confidentialite-page">
      <Header />
      
      <main className="py-16 md:py-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/" className="inline-flex items-center text-gray-600 hover:text-gray-900 mb-8">
            <ArrowLeft className="w-5 h-5 mr-2" />
            Retour à l'accueil
          </Link>

          <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-gray-200">
            <h1 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-8" style={{ letterSpacing: '-0.04em' }}>
              Politique de confidentialité
            </h1>

            <div className="prose prose-gray max-w-none">
              <p className="text-gray-600 mb-6">
                ACDC-Formation accorde une grande importance à la protection de vos données personnelles. 
                Cette politique de confidentialité vous informe sur la manière dont nous collectons, 
                utilisons et protégeons vos informations.
              </p>

              <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">1. Responsable du traitement</h2>
              <p className="text-gray-600 mb-4">
                <strong>Raison sociale :</strong> ACDC-Formation<br />
                <strong>Adresse :</strong> 7 avenue Paul Cézanne, 83600 Cogolin<br />
                <strong>Email :</strong> contact@acdc-formation.com<br />
                <strong>Responsable :</strong> [David Contal / François Schoonheere]
              </p>

              <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">2. Données collectées</h2>
              <p className="text-gray-600 mb-4">
                Nous collectons les données suivantes :
              </p>
              <ul className="list-disc pl-6 text-gray-600 mb-4">
                <li><strong>Données d'identification :</strong> nom, prénom, email, téléphone</li>
                <li><strong>Données professionnelles :</strong> entreprise, secteur d'activité, fonction</li>
                <li><strong>Données de navigation :</strong> adresse IP, pages visitées, durée de visite</li>
                <li><strong>Réponses aux formulaires :</strong> quiz diagnostic, formulaire de contact</li>
              </ul>

              <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">3. Finalités du traitement</h2>
              <p className="text-gray-600 mb-4">
                Vos données sont collectées pour :
              </p>
              <ul className="list-disc pl-6 text-gray-600 mb-4">
                <li>Répondre à vos demandes d'information et de contact</li>
                <li>Vous proposer des formations adaptées à vos besoins</li>
                <li>Établir des devis et contrats de formation</li>
                <li>Améliorer nos services et notre site web</li>
                <li>Respecter nos obligations légales et réglementaires</li>
              </ul>

              <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">4. Base légale</h2>
              <p className="text-gray-600 mb-4">
                Le traitement de vos données repose sur :
              </p>
              <ul className="list-disc pl-6 text-gray-600 mb-4">
                <li><strong>Votre consentement</strong> lors de la soumission des formulaires</li>
                <li><strong>L'exécution d'un contrat</strong> pour la réalisation de nos prestations</li>
                <li><strong>Notre intérêt légitime</strong> pour améliorer nos services</li>
                <li><strong>Nos obligations légales</strong> (facturation, comptabilité)</li>
              </ul>

              <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">5. Destinataires des données</h2>
              <p className="text-gray-600 mb-4">
                Vos données peuvent être transmises à :
              </p>
              <ul className="list-disc pl-6 text-gray-600 mb-4">
                <li>Notre équipe interne (commerciale, pédagogique, administrative)</li>
                <li>Nos sous-traitants techniques (hébergement, emailing)</li>
                <li>Les organismes de financement (OPCO) si nécessaire</li>
              </ul>
              <p className="text-gray-600 mb-4">
                Vos données ne sont jamais vendues à des tiers à des fins commerciales.
              </p>

              <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">6. Durée de conservation</h2>
              <p className="text-gray-600 mb-4">
                Nous conservons vos données pendant :
              </p>
              <ul className="list-disc pl-6 text-gray-600 mb-4">
                <li><strong>Prospects :</strong> 3 ans à compter du dernier contact</li>
                <li><strong>Clients :</strong> durée de la relation contractuelle + 5 ans</li>
                <li><strong>Données comptables :</strong> 10 ans (obligation légale)</li>
              </ul>

              <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">7. Vos droits</h2>
              <p className="text-gray-600 mb-4">
                Conformément au RGPD, vous disposez des droits suivants :
              </p>
              <ul className="list-disc pl-6 text-gray-600 mb-4">
                <li><strong>Droit d'accès :</strong> obtenir une copie de vos données</li>
                <li><strong>Droit de rectification :</strong> corriger des informations inexactes</li>
                <li><strong>Droit à l'effacement :</strong> demander la suppression de vos données</li>
                <li><strong>Droit à la portabilité :</strong> récupérer vos données dans un format standard</li>
                <li><strong>Droit d'opposition :</strong> vous opposer au traitement de vos données</li>
                <li><strong>Droit de limitation :</strong> limiter l'utilisation de vos données</li>
              </ul>
              <p className="text-gray-600 mb-4">
                Pour exercer ces droits, contactez-nous à : <strong>contact@acdc-formation.com</strong>
              </p>

              <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">8. Cookies</h2>
              <p className="text-gray-600 mb-4">
                Notre site utilise des cookies pour :
              </p>
              <ul className="list-disc pl-6 text-gray-600 mb-4">
                <li><strong>Cookies essentiels :</strong> fonctionnement du site</li>
                <li><strong>Cookies analytiques :</strong> mesure d'audience (Google Analytics)</li>
              </ul>
              <p className="text-gray-600 mb-4">
                Vous pouvez gérer vos préférences via la bannière de consentement ou les paramètres 
                de votre navigateur.
              </p>

              <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">9. Sécurité</h2>
              <p className="text-gray-600 mb-4">
                Nous mettons en œuvre des mesures techniques et organisationnelles appropriées 
                pour protéger vos données contre tout accès non autorisé, perte, altération ou 
                divulgation.
              </p>

              <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">10. Réclamation</h2>
              <p className="text-gray-600 mb-4">
                Si vous estimez que vos droits ne sont pas respectés, vous pouvez introduire 
                une réclamation auprès de la CNIL (Commission Nationale de l'Informatique et 
                des Libertés) : <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-blue-700 hover:underline">www.cnil.fr</a>
              </p>

              <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">11. Modifications</h2>
              <p className="text-gray-600 mb-4">
                Cette politique peut être mise à jour. Nous vous informerons de tout changement 
                significatif par email ou via une notification sur notre site.
              </p>

              <p className="text-gray-500 text-sm mt-8">
                Dernière mise à jour : Février 2026
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default ConfidentialitePage;
